import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import EvnVar from '../../EnvVar'
import Cookies from 'js-cookie';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import certificateImage1 from '../../assests/certificates/registration.webp'
import certificateImage2 from '../../assests/certificates/best_ambassador.webp'
import certificateImage3 from '../../assests/certificates/ambassador.webp'
import certificateImage4 from '../../assests/certificates/participation.webp'
import { toPng } from 'html-to-image';
import download from 'downloadjs';

function EditProfileForm() {
    // bootstrap Modal file
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const baseURL = EvnVar()
    const [successMessage, setSuccessMessage] = useState('')
    const token = Cookies.get("jwt")
    const [profileData, setProfileData] = useState([])
    const profileDate = profileData.createdAt
    const registrationDate = new Date(profileDate)
    useEffect(() => {
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/profile`,
            headers: {
                Authorization: token,
            },
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                let result = JSON.stringify(response.data);
                let data = JSON.parse(result);
                
                // for (const key in data) {
                //     if (key === "createdAt") {
                //         const spaceData = key.replace("created", "created ")
                //         console.log(`Key: ${spaceData}`);
                //     }

                //     if (key === "updatedAt") {
                //         const spaceData = key.replace("updated", "updated ")
                //         console.log(`Key: ${spaceData}`);
                //     }
                // }
                setProfileData(data);
                SetFormData({
                    branch: data.branch,
                    phone: data.phone
                })
                console.log("profile Data Received", data);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
            })
    }, []);

    const [formData, SetFormData] = useState({
        branch: '',
        phone: ''
    })

    const handleChange = (e) => {
        const { id, value } = e.target
        const updatedFormData = {
            ...formData,
            [id]: value,
        }
        if (id === 'phone') {
            updatedFormData.phone = value.replace(/\D/g, '').slice(0, 10);
        }

        SetFormData(updatedFormData)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('Form Data Submitted:', formData);

        const userData = JSON.stringify(
            {
                "branch": formData.branch,
                "phone": formData.phone,
            }
        )

        // console.log('Sending to api:', JSON.parse(userData));


        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/profile`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,
            },
            data: userData,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                const responseData = JSON.stringify(response.data)
                const responseJson = JSON.parse(responseData)
                // console.log("dataResponse:", responseJson, responseJson.msg);
                setSuccessMessage(responseJson.msg)
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const ref = useRef();

    const handleDownload = () => {
        if (ref.current === null) {
            return;
        }

        toPng(ref.current, { cacheBust: true })
            .then((dataUrl) => {
                download(dataUrl, 'certificate.png');
                console.log(dataUrl)
            })
            .catch((err) => {
                console.error('Could not generate image', err);
            });
    }

    const [openCertificate, setOpenCertificate] = useState()


    return (
        <>
            <div className="download-certificate">
                <h4>Download Badge:</h4>
                <button className="download-btn me-2" variant="primary" onClick={() => { handleShow(); setOpenCertificate("registration") }}>Registration</button>
                <button className="download-btn me-2" variant="primary" onClick={() => { handleShow(); setOpenCertificate("performance") }}>Best Performance</button>
                <button className="download-btn me-2" variant="primary" onClick={() => { handleShow(); setOpenCertificate("ambassador") }}>Lead Ambassador</button>
                <button className="download-btn me-2" variant="primary" onClick={() => { handleShow(); setOpenCertificate("participation") }}>Participation</button>
            </div>
            <form className="row g-3" onSubmit={handleSubmit}>
                {successMessage && <p className='text-success' style={{ fontSize: "24px", textAlign: "center" }}>{successMessage}</p>}
                {profileData && Object.entries(profileData).map(([key, val], index) => {
                    if (key === "phone" || key === "branch" || key === "mebership_status" || key === "role") return;
                    return (
                        <div className="col-lg-6" key={index}>
                            <label className="form-label" style={{ textTransform: "capitalize" }}>{key === "createdAt" ? "created At" : key === "updatedAt" ? "updated At" : key}</label>
                            <input className="form-control" value={val ?? ""} disabled />
                        </div>
                    )
                })}
                <div className="col-lg-6">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input type='tel' className="form-control" id="phone" value={formData.phone} required onChange={handleChange} placeholder="Phone" />
                </div>
                <div className="col-lg-6">
                    <label htmlFor="branch" className="form-label">
                        Branch Name</label>
                    <input type="text" className="form-control" id="branch" placeholder="Branch Name" value={formData.branch} required onChange={handleChange} />
                </div>
                <div className="col-lg-12 d-flex justify-content-center">
                    <button type="submit" className="btn btn-primary">Update</button>
                </div>
                {successMessage && <p className='text-success' style={{ fontSize: "24px", textAlign: "center" }}>{successMessage}</p>}
            </form>


            {/* Download certificate modal */}
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Download Badge</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {openCertificate === "registration" &&
                        <div ref={ref} className='certificate-image position-relative'>
                            <img src={certificateImage1} className='img-fluid' style={{ width: "100%" }} alt="Badge" />
                            <div className='position-absolute' style={{ left: "60px", right: "60px", top: "47%" }}>
                                <p style={{ marginBottom: "0", fontSize: "16px" }}>This is to certify that CA./Mr./Ms. <span style={{ fontWeight: "bold" }}>{profileData.fullname}</span> is successfully registered as an “Ambassador” for the FTL Mela which is scheduled to be held on 17th August, 2024, conducted by the Finance and Tax Literacy Directorate of the Institute of Chartered Accountants of India and He pledges to Financial Literate citizen of India.</p>
                            </div>
                            <div style={{ position: "absolute", left: "180px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{profileData.branchName ?? ""}</div>
                            <div style={{ position: "absolute", right: "102px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{registrationDate.toLocaleDateString()}</div>
                        </div>
                    }
                    {openCertificate === "performance" &&
                        <div ref={ref} className='certificate-image position-relative'>
                            <img src={certificateImage2} className='img-fluid' style={{ width: "100%" }} alt="Badge" />
                            <div className='position-absolute' style={{ left: "60px", right: "60px", top: "47%" }}>
                                <p style={{ marginBottom: "0", fontSize: "16px" }}>This is to certify that CA./Mr./Ms. <span style={{ fontWeight: "bold" }}>{profileData.fullname}</span> has been chosen as the <span style={{ fontWeight: "bold" }}>{"Second"}</span> (First/ Second/ Third) “Best Ambassador” from <span style={{ fontWeight: "bold" }}>{"Branch"}</span> (State/ Branch/ Region/ PAN India) at the FTL Mela on 17th August, 2024 by the Finance and Tax Literacy Directorate of the Institute of Chartered Accountants of India.</p>
                            </div>
                            <div style={{ position: "absolute", left: "180px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{profileData.branchName ?? ""}</div>
                            <div style={{ position: "absolute", right: "102px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{registrationDate.toLocaleDateString()}</div>
                        </div>
                    }
                    {openCertificate === "ambassador" &&
                        <div ref={ref} className='certificate-image position-relative'>
                            <img src={certificateImage3} className='img-fluid' style={{ width: "100%" }} alt="Badge" />
                            <div className='position-absolute' style={{ left: "60px", right: "60px", top: "47%" }}>
                                <p style={{ marginBottom: "0", fontSize: "16px" }}>This is to certify that CA./Mr./Ms. <span style={{ fontWeight: "bold" }}>{profileData.fullname}</span> successfully enrolled <span style={{ fontWeight: "bold" }}>{"123456"}</span> (Number) Participants as an “Ambassador” for the FTL Mela which is scheduled to be held on 17th August, 2024, conducted by the Finance and Tax Literacy Directorate of the Institute of Chartered Accountants of India.</p>
                            </div>
                            <div style={{ position: "absolute", left: "180px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{profileData.branchName ?? ""}</div>
                            <div style={{ position: "absolute", right: "102px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{registrationDate.toLocaleDateString()}</div>
                        </div>
                    }
                    {openCertificate === "participation" &&
                        <div ref={ref} className='certificate-image position-relative'>
                            <img src={certificateImage4} className='img-fluid' style={{ width: "100%" }} alt="Badge" />
                            <div className='position-absolute' style={{ left: "60px", right: "60px", top: "47%" }}>
                                <p style={{ marginBottom: "0", fontSize: "16px" }}>This is to certify that Mr./Ms. <span style={{ fontWeight: "bold" }}>{profileData.fullname}</span> has successfully participated in the FTL Mela held on 17th August, 2024 at <span style={{ fontWeight: "bold" }}>{profileData.location ?? "Delhi"}</span> (Location) which was organised by the Finance and Tax Literacy Directorate of the Institute of Chartered Accountants of India.</p>
                            </div>
                            <div style={{ position: "absolute", left: "180px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{profileData.branchName ?? ""}</div>
                            <div style={{ position: "absolute", right: "102px", bottom: "52px", fontSize: "10px", fontWeight: "bold" }}>{registrationDate.toLocaleDateString()}</div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-check d-flex ps-0'>
                        <input className='form-check-input' type="checkbox" id="term-condition" style={{marginTop: "0", width: "1.25rem", height: "1.25rem", marginLeft: "0", padding: "0", marginRight: "0.5rem"}}/>
                        <label className="form-check-label" htmlFor="term-condition">I declare that I have no pending criminal cases and have not been convicted of any crimes. I affirm that this content is original and free of copyright issues. I understand that if I provide false information or documents, my Ambassadorship will be terminated immediately, and I will face applicable legal penalties.</label>
                    </div>
                    <Button variant="primary" onClick={handleDownload}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EditProfileForm
